<template>
  <!-- <div class="spinner-snake" :style="{
    'border-top-color': spinnerColor,
    'border-left-color': spinnerColor,
    'border-bottom-color': spinnerColor,
    'height': spinnerSize,
    'width': spinnerSize
    }">
  </div> -->
  <div class="spinner-box">
    <img :src="imgUrl" width="30px" class="spinner-snake"/>
    <div class="loading-text">{{text}}</div>
  </div>
</template>

<script>

  export default {
    name: 'snake',
    props: {
      size: [Number, String],
      color: String,
      text: String
    },
    data(){
      return{
        imgUrl: require('../../image/item/group2.png')
      }
    },
    computed: {
      spinnerColor() {
        return this.color || this.$parent.color || '#ccc';
      },

      spinnerSize() {
        return (this.size || this.$parent.size || 28) + 'px';
      }
    }
  };
</script>

<style lang="css">
  .spinner-box {
    text-align: center;
  }
  .spinner-snake {
    animation: spinner-rotate 0.8s infinite linear;
    /* border: 4px solid transparent;
    border-radius: 50%; */
  }

  @keyframes spinner-rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loading-text {
    font-size: 14px;
    margin-top: 5px;
    color: #BDC0C5;
  }
</style>
